module.exports = __webpack_public_path__ + "img/2_242.e4f4f4cd.png";